<template lang="pug">
.register-row
  .register-group
    .register-key(v-if="keyName || required || $slots.optionText")
      span.key-name(v-if="keyName") {{ keyName }}
      span.validation-label(v-if="required == true") 必須
      slot(name="optionText")

    .register-value 
      select.register-form.input-select(
        v-model="_value"
        :name="name"
        v-validate="validationRules"
        :data-vv-as="(validationKeyName) ? validationKeyName : keyName"
        :style="styles"
        :class="[ { noinput: (required == true && (_value == null || _value === '')) }, { 'is-placeholder': (_value == null || _value === '') } ]"
        @change="onChange"
      )
        option(v-if="placeholder" :value="null" disabled) {{ placeholder }}
        option(v-for="option in options" :key="option.value" :value="option.value") {{ option.label }}

    .error-messages(v-for="error in errors.collect(name)")
      label.error-message {{ error }}
      br
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";

/**
 * 入力要素コンポーネント(セレクトボックス入力)
 *
 * - セレクトボックスの入力をサポートする
 * - 既存の入力画面のスタイルが適用される
 * - バリデーターは親コンポーネントのものをInjectionして使用する
 *   - そのため、親コンポーネントでveevalidateをnewしておく必要がある
 */
@Component
export default class FormInputSelect extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  /** 親コンポーネントでv-modelで指定した値 */
  @Prop()
  value!: string | number | boolean | null;

  /** リスト項目 */
  @Prop()
  options!: Array<{ value: number | string; label: string }>;

  /** 項目名 */
  @Prop({ required: true, type: String })
  keyName!: string;

  /** プレースホルダー */
  @Prop({
    default: () => {
      return "";
    },
    type: String
  })
  placeholder!: string;

  /** 必須か */
  @Prop({
    default: () => {
      return false;
    },
    type: Boolean
  })
  required!: boolean;

  /** name属性の値 */
  @Prop({ required: true, type: String })
  name!: string;

  /** veevalidateに渡すバリデーション項目名 */
  @Prop({
    default: () => {
      return "";
    },
    type: String
  })
  validationKeyName!: string;

  /** veevalidateに渡すバリデーションルール */
  @Prop()
  validationRules!: string;

  /** スタイル(主にサイズ指定) */
  @Prop({
    default: () => {
      return {};
    },
    type: Object
  })
  styles!: any;

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _value(): string | number | boolean | null {
    return this.value;
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _value(newValue: string | number | boolean | null) {
    this.$emit("input", newValue);
    return;
  }

  public onChange(e: any) {
    this.$emit("change", e && e.target ? e.target.value : this.value);
    return;
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";

.input-select {
  min-width: 340px;

  &.is-placeholder {
    color: #757575;
  }
  option {
    color: $font-base-color;
  }
  option[disabled] {
    color: #757575;
  }
}
</style>
